import React, { useState } from "react";

import { useQueryString } from "app/context";
import { Icon, Badge } from "@culturehq/components";
import { getQueryStringKey, t } from "app/utils";
import { getIcon, getFilledIcon } from "constants/tagsTypes";
import isTarget from "app/utils/isTarget";

const Tags = ({
  onTagClicked,
  tags,
  title,
  icon,
  iconFilled,
  color,
  entityFormat = false,
  queryKey,
  selectedFilters = [],
  filter = true,
  type,
  orgName
}) => {
  const { onToggleQueryStringValue } = useQueryString();
  const [expanded, setExpanded] = useState(false);
  const MAX_NUMBER_TO_SHOW = 5;
  const isTargetOrg = isTarget(orgName);

  const handleOnTagClicked = tag => {
    if (filter) {
      if (entityFormat) {
        onToggleQueryStringValue(getQueryStringKey(tag.type), tag.id);
      } else {
        onToggleQueryStringValue(queryKey, tag.id);
      }
    }

    if (onTagClicked) {
      onTagClicked(tag);
    }
  };

  const handleClick = isExpanded => {
    setExpanded(isExpanded);
  };

  const tagSelected = (tag, type) => (
    selectedFilters.filter(
      filter => filter.value === tag.id && (filter.category === type || (filter.category === "class years" && type === "classYears"))
    ).length > 0
  );

  const getTagIcon = tag => {
    if (entityFormat) {
      if (tagSelected(tag, tag.type)) {
        return getFilledIcon(tag.type);
      }
      return getIcon(tag.type);
    }

    if (tagSelected(tag, type)) {
      return iconFilled;
    }
    return icon;
  };

  if (!tags || tags.length === 0) {
    return <></>;
  }

  const TagsTitleStyle = orgName === "microsoft" ? {} : { color };

  return (
    <div className={`Tags ${isTargetOrg ? "target-Tags" : ""}`}>
      <div className="Tags__title">
        <h2 style={TagsTitleStyle}>{title}</h2>
      </div>
      <div className="chq-ffd-tags">
        {expanded
          ? (
            <>
              {tags.map(tag => (
                <Badge className={`${tagSelected(tag, entityFormat ? tag.type : type) ? "Selected" : ""} ${filter ? "" : "No-Action"}`} key={entityFormat ? `${tag.type}-${tag.id}` : tag.id} onClick={() => handleOnTagClicked(tag)} aria-label={`Select ${t(tag.name)} as filter`}>
                  {!isTargetOrg && <Icon icon={getTagIcon(tag)} />}
                  {tag.name}
                </Badge>
              ))}
              <div key="minus-option" className="Tags__minus-option">
                <span onClick={() => handleClick(false)}>
                  <Icon icon="minus" />
                  {" "}
                  show less
                </span>
              </div>
            </>
          ) : (
            <>
              {tags.map((tag, index) => (
                (index < MAX_NUMBER_TO_SHOW) && (
                  <Badge className={`${tagSelected(tag, entityFormat ? tag.type : type) ? "Selected" : ""} ${filter ? "" : "No-Action"}`} key={entityFormat ? `${tag.type}-${tag.id}` : tag.id} onClick={() => handleOnTagClicked(tag)} aria-label={`Select ${t(tag.name)} as filter`}>
                    {!isTargetOrg && <Icon icon={getTagIcon(tag)} />}
                    {tag.name}
                  </Badge>
                )
              ))}
              {tags.length > MAX_NUMBER_TO_SHOW && (
                <div key="plus-option" className="Tags__plus-option">
                  <span onClick={() => handleClick(true)}>
                    <Icon icon="plus" />
                    {" "}
                    {tags.length - MAX_NUMBER_TO_SHOW}
                  </span>
                </div>
              )}
            </>
          )}
      </div>
    </div>
  );
};

export default Tags;
